import { render } from "./CatErpForm.vue?vue&type=template&id=67892456&scoped=true"
import script from "./CatErpForm.vue?vue&type=script&lang=js"
export * from "./CatErpForm.vue?vue&type=script&lang=js"

import "./CatErpForm.vue?vue&type=style&index=0&id=67892456&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67892456"]])

export default __exports__